import React from 'react';
import PostListItem from './PostListItem';
import CreatePost from './CreatePost';
import { getPosts } from '../../api/Request';

class PostList extends React.Component {
	state = {
		posts: []
	};

	renderList() {
		return this.state.posts.map((post, i) => {
			return <PostListItem post={post} key={post._id} />;
		});
	}
	componentDidMount() {
		this.getPosts();
	}

	async getPosts() {
		const res = await getPosts();
		this.setState({ posts: res.data });
	}

	render() {
		return (
			<section className="section allsection">
				{/* <div className="box"> */}
				<nav className="breadcrumb" aria-label="breadcrumbs">
					<ul>
						<li className="is-active">
							<a href={() => false} aria-current="page">
								Annonces
							</a>
						</li>
					</ul>
				</nav>
				{/* </div> */}

				<div className="container py-4">
					<div className="box">
						<h2 className="title has-text-centered mb-6">
							Les dernières annonces
						</h2>

						<div className="columns is-multiline">{this.renderList()}</div>
						<CreatePost />
					</div>
					<nav>
						<div
							className="pagination is-centered"
							role="navigation"
							aria-label="pagination"
						>
							<a className="pagination-previous" href={() => false} disabled>
								Precedent
							</a>
							<a className="pagination-next" href={() => false} disabled>
								Suivant
							</a>
							<ul className="pagination-list">
								<li>
									<a
										className="pagination-link is-current"
										aria-label="Page 1"
										aria-current="page"
										href={() => false}
									>
										1
									</a>
								</li>
								{/* <li><a className="pagination-link" aria-label="Goto page 2">2</a></li>
        <li><a className="pagination-link" aria-label="Goto page 3">3</a></li>
        <li><span className="pagination-ellipsis">…</span></li>
        <li><a className="pagination-link" aria-label="Goto page 47">5</a></li>
        <li><span className="pagination-ellipsis">…</span></li>
        <li><a className="pagination-link" aria-label="Goto page 86">10</a></li> */}
							</ul>
						</div>
					</nav>
				</div>
			</section>
		);
	}
}

export default PostList;
